import { z } from "zod";

/**
 * UsuariosCadastroFormSchema
 */

export const UsuariosCadastroFormSchema = z.object({
  idUsuario: z.number().optional(),
  nome: z.string().min(3, "O nome deve ter no mínimo 3 caracteres").max(100, "O nome deve ter no máximo 100 caracteres"),
  login: z.string().min(3, "O login deve ter no mínimo 3 caracteres").max(50, "O login deve ter no máximo 50 caracteres"),
  email: z.string().email("E-mail inválido").max(100, "O e-mail deve ter no máximo 100 caracteres"),
  senha: z.string().nullable().default(null),
  confirmarSenha: z.string().nullable().default(null),
  bloqueado: z.coerce.number().default(0),
  idFuncionario: z.number().nullable().optional(),
  centroCustoRestrito: z.boolean().default(false),
  isConfigured: z.boolean().default(false),
  gruposUsuario: z.array(z.object({
    idGrupoAcesso: z.coerce.number(),
  })).nullable().default(null),

  restricoesCentroCusto: z.array(z.object({
    idCentroCusto: z.coerce.number(),
  })).nullable().default(null),

}).superRefine((data, ctx) => {
  if (data.senha !== null && data.senha.length > 0) {
    if (data.senha.length < 6) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["senha"],
        message: "A senha deve ter no mínimo 6 caracteres",
      });
    }

    if (data.senha.length > 50) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["senha"],
        message: "A senha deve ter no máximo 50 caracteres",
      });
    }

    if (!/[0-9]/.test(data.senha)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["senha"],
        message: "A senha deve conter pelo menos um número",
      });
    }

    if (!/[A-Z]/.test(data.senha)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["senha"],
        message: "A senha deve conter pelo menos uma letra maiúscula",
      });
    }

    if (!/[a-z]/.test(data.senha)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["senha"],
        message: "A senha deve conter pelo menos uma letra minúscula",
      });
    }

    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(data.senha)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["senha"],
        message: "A senha deve conter pelo menos um caractere especial",
      });
    }

  }
});


export type UsuariosCadastroForm = z.infer<typeof UsuariosCadastroFormSchema>;


export const UsuariosCadastroFormDefaultValues: UsuariosCadastroForm = {
  nome: "",
  login: "",
  email: "",
  senha: "",
  confirmarSenha: "",
  bloqueado: 0,
  centroCustoRestrito: false,
  isConfigured: false,

  gruposUsuario: [],
  restricoesCentroCusto: [],
};  